module.exports = __webpack_public_path__ + "media/fyt_m5.c128c7f1.mp4";